<template>
  <v-dialog
    content-class="change-organization-default-domain"
    :value="internalValue"
    @keydown.esc="onCloseClick"
    @click:outside='onCloseClick'
    :width="width"
  >
    <v-card class="popup-wrapper" >
      <div class='close-action'>
        <span class='close_btn' @click='onCloseClick'>
          <span class="material-icons-outlined">
            close
          </span>
        </span>
      </div>
      <div class="content">
        <div class="title">
          {{ title }}
        </div>
        <div class='change-domain-warning-note'>
          <v-alert
            outlined
            type="info"
          >
            {{ $t('change.default.domain.warning') }}
          </v-alert>
        </div>
        <div class='change-domain-form'>
          <v-autocomplete
            class-name="domain-select"
            :placeholder="$t('select')"
            :items='allItemsOptions'
            item-text='name'
            item-value='id'
            :append-icon="'expand_more'"
            :label='$t("change.default.domain.placeholder")'
            v-model='domain'
            dense
            outlined
            autofocus
            return-object
          />
        </div>
      </div>
      <div class="buttons">
        <v-btn small depressed class="cancel-button btn-secondary" @click="onCloseClick"> {{ $t('confirm.cancel') }} </v-btn>
        <v-btn small depressed class="save-button btn-primary" :disabled="saveButtonDisabled" @click="onSaveClick" :loading='loading'>
          {{ $t('save') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'ChangeOrganizationDefaultDomain',
  components: {
  },
  props: {
    loading: {
      required: false,
      type: Boolean,
      default: false,
    },
    value: {
      required: true,
      type: Boolean,
    },
    width: {
      type: Number,
      required: false,
      default: 600,
    },
    organization: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      domain: '',
    };
  },
  watch: {
    internalValue() {
      this.domain = '';
    },
  },
  methods: {
    async onSaveClick() {
      const payload = {
        domain: this.domain,
        organization: this.organization.name,
      };
      await this.$emit('saveLinkedDomains', payload);
    },
    onCloseClick() {
      this.$emit('closed');
    },
  },
  computed: {
    ...mapGetters(['configurationDomains', 'domainsPerOrganization']),
    currentDomainsLinked() {
      return this.domainsPerOrganization.get(this.organization.name) || [];
    },
    domainOptions() {
      return [...this.configurationDomains]
        .filter(domain => this.currentDomainsLinked.includes(domain.configData));
    },
    allItemsOptions() {
      return [...this.domainOptions]
        .map(item => item.configData)
        .filter(item => this.organization.domain !== item)
        .sort();
    },
    saveButtonDisabled() {
      return !this.domain.length;
    },
    title() {
      return this.$t('change.default.domain.popup.title');
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.change-organization-default-domain {
  .v-text-field--outlined.v-input--dense > .v-input__control > .v-input__slot {
    min-height: $space-10;
    max-height: $space-10;
  }

  .v-chip .v-chip__close.v-icon {
    font-size: $font-size-2xl;
  }

  .v-chip.v-size--default {
    height: rem(25);
  }

  .v-input__append-inner.v-input__append-inner {
    margin-top: $space-1;
  }

  .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-input--dense .v-select__selections {
    min-height: rem(45);
    max-height: rem(45);
  }
}
</style>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.v-autocomplete__content.v-menu__content .v-select-list {
  position: relative;
}

.change-organization-default-domain {
  .popup-wrapper {
    max-width: rem(600);
    padding: $space-8 $space-10;

    .close-action {
      float: right;

      .close_btn {
        float: right;
        margin-top: rem(-15);
        margin-right: rem(-15);

        &:hover {
          cursor: pointer;
          color: var(--brand-primary);
        }
      }
    }

    .content {
      .title {
        margin-bottom: $space-4;
      }

      .change-domain-form {
        margin-top: $space-7;
      }
    }

    .buttons {
      text-align: right;
      padding-top: $space-7;

      .cancel-button {
        height: $btn-height-md;
        border-radius: $radius-sm;
      }

      .save-button {
        height: $btn-height-md;
        border-radius: $radius-sm;
        margin-left: $space-2;
      }
    }
  }
}
</style>
